"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Delivery_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 2.667a.5.5 0 01.5-.5h6.89a.5.5 0 01.5.5v1.929h3.687c.539 0 1.007.368 1.134.891l.411 1.698 1.791.923c.388.2.632.6.632 1.037v2.57c0 .644-.522 1.167-1.167 1.167h-1.574a2.012 2.012 0 11-4.018 0H7.392v-7.74a.505.505 0 01-.002-.047V3.167H1a.5.5 0 01-.5-.5zm9.114 9.215a2.01 2.01 0 013.362 0h1.902a.167.167 0 00.167-.167v-2.57a.167.167 0 00-.09-.148l-2.197-1.133-.519-2.141a.167.167 0 00-.162-.127H8.393v6.286h1.221zm-8.188-6.18a.5.5 0 01.5-.5h3.6a.5.5 0 110 1h-3.6a.5.5 0 01-.5-.5zm1.68 2.536a.5.5 0 000 1h2.332a.5.5 0 000-1H3.105zm1.177 3.036a.5.5 0 100 1h1a.5.5 0 000-1h-1zM11.295 14a1.012 1.012 0 100-2.024 1.012 1.012 0 000 2.024z",
    fill: props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Delivery_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z",
    fill: "#fff"
  }))));
};
SvgDelivery.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgDelivery.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgDelivery;
exports["default"] = _default;
module.exports = exports.default;